import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import './select.css';
import Select from 'react-select';
import { components } from 'react-select';
import { Input } from 'reactstrap';

const SelectMut = (props) => {
  const { values } = useFormikContext();
  const [err, setErr] = useState(false);
  const readOnly = props.readOnly;
  let { name, invalid, inMonthLoan, options } = props;
  const [field, meta, helpers] = useField(name);
  options = React.useMemo(
    () =>
      options?.filter((o) => {
        if (values?.inMonthLoan === 'N') {
          return readOnly ? !o.value || meta?.value?.split(',').includes(o.value) : !o.readOnly && o.value;
        } else if (values?.inMonthLoan === 'Y') {
          return readOnly ? !o.value || meta?.value?.split(',').includes(o.value) : !o.readOnly && o.value && !['PG_LKC', 'PG_LKDV'].includes(o.value);
        }
      }),
    [options, readOnly, meta.value, values?.inMonthLoan],
  );

  const totalList2 = React.useMemo(
    () =>
      options?.filter((op) => {
        return field?.value?.split(',').includes(op.value);
      }),
    [options, readOnly, meta.value],
  );

  const handleMultipleChange = (selectList, type) => {
    if (selectList?.length > 0) {
      if (selectList?.length > 3) {
        setErr(true);
        return;
      }
      let values = '';
      selectList?.forEach((s) => {
        values = values + s.value + ',';
      });
      helpers.setValue(values);
      setErr(false);
      helpers.setError(false);
      helpers.setTouched(true);
    } else {
      helpers.setValue(null);
      helpers.setError(false);
      helpers.setTouched(true);
    }
  };
  const customStyles = {
    singleValue: base => ({
      ...base,
    }),
    input: base => ({
      ...base,
    }),
    indicatorSeparator: () => {
    },
    dropdownIndicator: defaultStyles => ({
      ...defaultStyles,
      color: 'purple',
      paddingRight: '0px',
      fontSize: '1px',
      minHeight: 1,
      width: '24px',
    }),
    menu: provided => ({
      ...provided,
      zIndex: 9999,
      marginTop: '0px',
      padding: '0px',
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected, isCLick }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
            ? '#fff'
            : isFocused
              ? 'gray'
              : undefined,
        //'&:hover': { backgroundColor: 'gray' },
        color: isDisabled
          ? '#332f2f'
          : isSelected
            ? '#fff'
            : isFocused
              ? '#fff'
              : undefined,
        // fontSize: '1444px'
        // padding: '0px',
      };
    },
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: '#fff',
      ':hover': {
        // backgroundColor: '#6c0cd3',
        color: '#fff',
      },
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: '#52178d',
      };
    },
    multiValueLabel: (base) => ({
      ...base,
      color: '#fff',
    }),
    control: (base, state) => ({
      ...base,
      // color: '#fff',
      border: `1px solid ${err ? '#dc3545' : '#ced4da'}`,
      borderRadius: '3px',
      boxShadow: 'none',
      '&:hover': {
        border: '1px solid #e87722',
        // boxShadow: '0 0 0 2px #e87722;',
      },
      '&:focus': {
        // border: '1px solid #e87722',
        boxShadow: '0 0 0 2px #e87722',
      },
    }),
  };
  const NoOptionsMessage = props => {
    return (
      <components.NoOptionsMessage {...props}>
        {null}
      </components.NoOptionsMessage>
    );
  };

  return (
    <>
      <Select
        {...field}
        value={totalList2}
        id={name}
        onChange={handleMultipleChange}
        options={options}
        isMulti
        isDisabled={readOnly}
        className={'mut-select'}
        isClearable
        components={{ NoOptionsMessage }}
        placeholder='Chọn tối đa 3 sản phẩm thôi bạn nhá '
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
          },
        })}
        styles={customStyles}
      />
      <Input
        hidden={true}
        {...field}
        value={field.value || ''}
        invalid={invalid || (meta.error && meta.touched)}
        id={name}
      />
      <small className='form-text text-danger' style={{ display: !err ? 'none' : '' }}>Bạn đừng chọn quá 3 sản
        phẩm</small>
    </>
  );
};

SelectMut.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      readOnly: PropTypes.bool,
    }),
  ),
  readOnly: PropTypes.bool,
  invalid: PropTypes.any,
};

export default SelectMut;
